import { useMemo } from 'react'
import { useThree } from '@react-three/fiber'
import theme from 'tailwindcss/defaultTheme'

export const useScreenSize = () => {
    const screenLG = Number(theme.screens.lg.replace('px', ''))
    const screenMD = Number(theme.screens.md.replace('px', ''))
    const screenSM = Number(theme.screens.sm.replace('px', ''))

    const {
        size: { width }
    } = useThree()

    const [LG, MD, SM, XS] = useMemo(() => {
        return [
            width > screenLG,
            width <= screenLG && width > screenMD,
            width <= screenMD && width > screenSM,
            width <= screenSM
        ]
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [width])

    return { LG, MD, SM, XS }
}
